export const mi = {

    locale: 'mi',
    pluralRuleFunction(e, t) {
        return t && e === 1 ? 'one' : 'other';
    }
}